import React from 'react';
import SectionTitle from '../common/SectionTitle'; // Using the provided SectionTitle component

// It's good practice to define styles in a separate CSS file.
// These are example inline styles for brevity and to "make it look similar".
// For a real application, use CSS classes and a stylesheet.

// This data would be defined in a parent component or imported.
// For the 'IA' component, you would pass:
// title = iaPageData.mainTitle
// description = iaPageData.mainDescription
// items = iaPageData.featureItems

export const iaPageData = {
  mainTitle: "IA para Empresas",
  mainDescription: "Aumente a produtividade, crie experiências diferenciadas e inove rápido com a UDS",
  businessCases: {
    title: "Principais casos de uso",
    subtitle: "da IA para empresas",
    description: "De atendimento ou produção de conteúdo, até processamento de documentos e dados em alto volume.",
    callToAction: "Veja o que sua empresa pode fazer com Gen AI.",
    items: [
      {
        title: "Aprimorar as experiências dos clientes",
        content: `Chatbots e assistentes virtuais
                Simplifique os processos de autoatendimento dos clientes e reduza os custos operacionais automatizando as respostas a consultas de atendimento ao cliente por meio de chatbots generativos baseados em IA, bots de voz e assistentes virtuais.

                Análise conversacional
                Analise o feedback não estruturado dos clientes com base em pesquisas, comentários em sites e transcrições de chamadas para identificar os principais tópicos, detectar sentimentos e revelar tendências emergentes.

                Assistência ao atendente
                Melhore o desempenho do agente e melhore a resolução no primeiro contato por meio da automação de tarefas, resumos, pesquisas aprimoradas na base de conhecimento e recomendações personalizadas de produtos de venda cruzada/venda adicional.

                Personalização
                Ofereça melhores experiências personalizadas e aumente o engajamento dos clientes com ofertas e comunicações selecionadas individualmente.`
      },
      {
        title: "Aumenta a produtividade dos funcionários",
        content: `Assistente de funcionários
Melhore a produtividade dos funcionários encontrando informações precisas com rapidez e facilidade, receba respostas precisas, faça resumos e crie, e resuma conteúdo por meio de uma interface de conversação.

Geração de código
Acelere o desenvolvimento de aplicações com sugestões de código baseadas nos comentários e no código do desenvolvedor.

Geração automatizada de relatórios
A IA generativa pode ser usada para gerar automaticamente relatórios financeiros, resumos e projeções, economizando tempo e reduzindo erros.`

      },
      {
        title: "Enriqueça a criatividade e a criação de conteúdo",
        content: `Marketing
Crie conteúdo de marketing envolvente, como postagens de blogs, atualizações em mídias sociais ou boletins informativos por e-mail, economizando tempo e recursos.

Vendas
Gere e-mails e mensagens personalizados com base no perfil e no comportamento de um cliente potencial, melhorando as taxas de resposta. Gere roteiros de vendas ou pontos de discussão com base no segmento, no setor e no produto ou serviço do cliente.

Desenvolvimento de produtos
A IA pode gerar vários protótipos de design com base em determinadas entradas e restrições, acelerando a fase de conceitualização ou otimizando projetos existentes com base no feedback dos usuários e em restrições especificadas.`
      },
      {
        title: "Acelere a otimização de processos",
        content: `Processamento de documentos
Melhore as operações comerciais extraindo e resumindo automaticamente dados de documentos e insights por meio de perguntas e respostas baseadas na IA generativa.

Aumento de dados
Gere dados sintéticos para treinar modelos de ML quando o conjunto de dados original for pequeno, desequilibrado ou sensível.

Otimização da cadeia de suprimentos
Melhore a logística e reduza os custos avaliando e otimizando diferentes cenários da cadeia de suprimentos.`
      }
    ]
  },
  featureItems: [ // This flat array is passed as the 'items' prop
    {
      id: "microphone",
      iconPlaceholder: "microphone",
      title: "Converter voz em texto automaticamente",
      subhead: "Identifica o que é dito em vários idiomas e converte em texto.",
      description: "Extrai insights de chamadas com clientes, vídeos e mais. Compreende vocabulários específicos e legenda conteúdos automaticamente sob demanda.",
      linkText: "Crie soluções de reconhecimento de voz"
    },
    {
      id: "image",
      iconPlaceholder: "image",
      title: "Reconhecer imagens rápido e com precisão",
      subhead: "Análise imediata de imagens com hiperfoco em identificar padrões definidos por você.",
      description: "Analisa imagens instantaneamente e reconhece rostos, textos, padrões e qualquer outro elemento para extrair informações ou classificar conteúdos.",
      linkText: "Crie soluções de reconhecimento de imagens"
    },
    {
      id: "file-alt",
      iconPlaceholder: "file-alt",
      title: "Extrair dados de textos impressos ou manuscritos",
      subhead: "Extrai textos de documentos impressos ou manuscritos e reconhece padrões.",
      description: "Vai além do OCR: essa inteligência identifica, entende e extrai dados específicos de documentos com precisão, sejam manuscritos, tabelas ou elementos visuais.",
      linkText: "Crie soluções baseadas em extração de dados"
    },
    {
      id: "thumbs-up",
      iconPlaceholder: "thumbs-up",
      title: "Recomendar itens de forma personalizada",
      subhead: "Recomende itens para seus usuários de acordo com o comportamento deles.",
      description: "Gera recomendações altamente relevantes para seus usuários em sites, apps, pushs, SMS e muito mais, levando os dados e comportamentos dos usuários em conta.",
      linkText: "Crie recomendações altamente personalizadas"
    },
    {
      id: "robot",
      iconPlaceholder: "robot",
      title: "Assistente de Trabalho Inteligente",
      subhead: "Baseado em dados, experiências e sistemas corporativos da sua empresa.",
      description: "Gera respostas relevantes, resolve problemas e simplifica tarefas. Acelera decisões, estimula a criatividade e inovação no trabalho.",
      linkText: "Crie seu Assistente de Trabalho Inteligente"
    },
    {
      id: "magic",
      iconPlaceholder: "magic",
      title: "Inteligências Artificiais para você personalizar",
      subhead: "Inteligências Artificiais pré-treinadas (Modelos de Base) para qualquer contexto.",
      description: "Gera textos e conteúdos originais, detalha tarefas e conversar, pesquisa em textos e imagens, resume textos complexos e gera imagens realistas.",
      linkText: "Personalize sua Inteligência Artificial"
    },
    {
      id: "lightbulb",
      iconPlaceholder: "lightbulb",
      title: "Insights valiosos para qualquer setor de mercado",
      subhead: "Explore documentos e encontre insights valiosos para o negócio.",
      description: "Descobre informações valiosas em tickets, documentos, análises de produtos, e-mails e outros: identifica sentimentos e insights.",
      linkText: "Extraia insights valiosos da sua interação"
    },
    {
      id: "cogs",
      iconPlaceholder: "cogs",
      title: "Machine Learning totalmente personalizado",
      subhead: "Desenvolva, treine e implante sistemas que aprendem sozinhos.",
      description: "Aprendem sozinhos sobre sua operação, identificam padrões e tomam decisões com o mínimo de intervenção humana.",
      linkText: "Crie soluções com Aprendizado de Máquina"
    }
  ]
};

const cardStyle = {
  background: '#fff',
  border: '1px solid #eee',
  borderRadius: '12px',
  padding: '32px',
  marginBottom: '30px',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  textAlign: 'left',
};

const iconStyle = {
  fontSize: '32px',
  marginBottom: '24px',
  color: '#0d6efd',
  width: '48px',
  height: '48px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const cardTitleStyle = {
  fontSize: '18px',
  fontWeight: '600',
  marginBottom: '12px',
  color: '#2E3B4E',
  lineHeight: '1.4',
};

const cardSubheadStyle = {
  fontSize: '15px',
  marginBottom: '12px',
  color: '#2E3B4E',
  lineHeight: '1.6',
};

const whatItDoesStyle = {
  fontSize: '14px',
  color: '#0d6efd',
  fontWeight: '500',
  marginBottom: '12px',
  display: 'block',
};

const cardDescriptionStyle = {
  fontSize: '14px',
  lineHeight: '1.6',
  color: '#6B7A90',
  marginBottom: '24px',
};

const cardLinkStyle = {
  fontSize: '14px',
  fontWeight: '500',
  color: 'black',
  textDecoration: 'underline',
  

  display: 'inline-block',
};

const groupHeadingStyle = {
//   textAlign: 'center',
  fontSize: '1.75rem',
  fontWeight: '600',
  marginTop: '150px',
  marginBottom: '60px',

  marginBlock: '40px 60px', // More spacing around group titles
};

const businessCaseStyle = {
  background: '#f8f9fa',
  padding: '80px 0',
  display: 'flex',
  justifyContent: 'center',
  marginTop: '60px',
};

const businessCaseContainer = {
  display: 'flex',
  width: '70%',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  gap: '40px',
};

const businessCaseLeft = {
  flex: '0 0 40%',
};

const businessCaseRight = {
  flex: '0 0 55%',
};

const businessCaseTitle = {
  fontSize: '2.5rem',
  fontWeight: 'bold',
  marginBottom: '20px',
  lineHeight: '1.2',
};

const businessCaseSubtitle = {
  fontSize: '2.5rem',
  color: '#666',
  marginBottom: '30px',
  lineHeight: '1.2',
};

const businessCaseDescription = {
  fontSize: '1.1rem',
  color: '#666',
  marginBottom: '20px',
  lineHeight: '1.5',
};

const accordionItemStyle = {
  border: '1px solid #e5e7eb',
  borderRadius: '8px',
  marginBottom: '16px',
  overflow: 'hidden',
};

const accordionButtonStyle = {
  width: '100%',
  padding: '20px',
  textAlign: 'left',
  background: 'white',
  border: 'none',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  cursor: 'pointer',
  fontSize: '1.1rem',
  fontWeight: '500',
};

const accordionContentStyle = {
  padding: '20px',
  background: 'white',
  borderTop: '1px solid #e5e7eb',
};


const IA = ({ paddingTop, title, description, items }) => {
  const [activeAccordion, setActiveAccordion] = React.useState(null);

  const toggleAccordion = (index) => {
    setActiveAccordion(activeAccordion === index ? null : index);
  };

  const firstGroupItems = iaPageData.featureItems?.slice(0, 4) || [];
  const secondGroupItems = iaPageData.featureItems?.slice(4, 8) || [];

  const renderFeatureCard = (item) => (
      <div className="col-lg-3 col-md-6 col-sm-12" key={item.id}>
        <div style={cardStyle}>
          <i className={`far fa-${item.id}`} style={iconStyle}></i>
          <h5 style={cardTitleStyle}>{item.title}</h5>
          <p style={cardSubheadStyle}>{item.subhead}</p>
          <span style={whatItDoesStyle}>O QUE FAZ</span>
          <p style={cardDescriptionStyle}>{item.description}</p>
          
        </div>
        <div style={{display: 'flex', justifyContent: 'center', marginBottom: '10px'}}>
        {item.linkText && <a href="#" style={cardLinkStyle}>{item.linkText}</a>}
        </div>
      </div>
    );

  return (
    <>
      <section
        className={`feature-section ${paddingTop ? 'ptb-120' : 'pt-60 pb-120'}`}
        style={{ fontFamily: 'Arial, sans-serif' }} // Basic font style
      >
        <div className="container"> {/* Standard container class for centering and padding */}
          {/* Main Title and Description */}
          {title && description && (
            <SectionTitle
              title={title}
              description={description}
              // Assuming SectionTitle centers its content or you have CSS for it.
              // Add any props SectionTitle expects, e.g.
              // center (if it's a prop like <SectionTitle center />)
            />
          )}

          <div className="text-center mx-auto mt-5">
            <p><strong> IA para Empresas </strong></p>
          <h4>
  Aumente a <strong>produtividade</strong>, crie <strong>experiências diferenciadas</strong> e <strong>inove rápido</strong> com a UDS
</h4>
</div>


          {/* First Group of Features */}
          <div>
            <h3 style={groupHeadingStyle}>Converter, extrair e interpretar informações</h3>
            <div className="row justify-content-center" style={{ marginBottom: '150px' }} > 
              {firstGroupItems.map(renderFeatureCard)}
            </div>
          </div>

          {/* Second Group of Features */}
          <div>
            <h3 style={groupHeadingStyle}>Criar inteligências personalizadas</h3>
            <div className="row justify-content-center">
              {secondGroupItems.map(renderFeatureCard)}
            </div>
          </div>

          {/* Business Cases Section */}
          <div
  style={{
    width: '100vw',
    position: 'relative',
    left: '50%',
    right: '50%',
    marginLeft: '-50vw',
    marginRight: '-50vw',
    marginTop: '100px',
    background: '#f9f9f9', // opcional
    padding: '50px',
  }}
>
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
    }}
  >
    <div style={businessCaseContainer}>
      <div style={businessCaseLeft}>
        <h2 style={businessCaseTitle}>{iaPageData.businessCases.title}</h2>
        <h3 style={businessCaseSubtitle}>{iaPageData.businessCases.subtitle}</h3>
        <p style={businessCaseDescription}>{iaPageData.businessCases.description}</p>
        <p style={businessCaseDescription}>{iaPageData.businessCases.callToAction}</p>
      </div>
      <div style={businessCaseRight}>
        {iaPageData.businessCases.items.map((item, index) => (
          <div key={index} style={accordionItemStyle}>
            <button
              style={accordionButtonStyle}
              onClick={() => toggleAccordion(index)}
            >
              {item.title}
              <span>{activeAccordion === index ? '▼' : '▶'}</span>
            </button>
            {activeAccordion === index && (
              <div style={accordionContentStyle}>
                <p>
                  {item.content.split('\n').map((line, index) => (
                    <React.Fragment key={index}>
                      {line}
                      <br />
                    </React.Fragment>
                  ))}
                </p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  </div>
</div>

        </div>
      </section>
    </>
  );
};

export default IA;
